// extracted by mini-css-extract-plugin
export default {"info":"AuthInfo_info__l6cxs","enterText":"AuthInfo_enterText__l1PMQ","check":"AuthInfo_check__6+1NK"};